// extracted by mini-css-extract-plugin
export default {"card":"DashBoardCard_card__dMnqB","content":"DashBoardCard_content__GZKBg","iconTitle":"DashBoardCard_iconTitle__KdYJo","value":"DashBoardCard_value__1STL7"};